import FaqsList from "../components/faqs/FaqsList";

const Faqs = () => {
  return (
    <div className="pt-20 max-w-7xl mx-auto px-4">
      <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 md:grid-cols-3">
        <div className="md:col-span-2">
          <FaqsList />
        </div>
        <div className="md:col-span-1">
          {/* <NewsLetter /> */}
          <div className="mt-5">
           
             <img
              src="/images/faq/faq1.jpg"
              alt="img"
              className="sm:h-[300px] object-cover"
            />
             <img
           src="/images/faq/faq2.jpg"
              alt="img"
              className="sm:h-[300px] object-cover"
            />
             <img
                        src="/images/faq/faq3.jpg"
              alt="img"
              className="sm:h-[300px] w-full object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faqs;
